import { useCopiar } from '@common/hooks';
import { Button } from '@ntconsult/aluma-react';
import { Check, Copy } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { TextoParaCopiar } from './TextoParaCopiar';

/** O link é o mesmo para todos (P18); a página de cada campanha o expõe aqui e no "Lembrar". */
export const linkDaCampanha = (id: string) => `${window.location.origin}/responder/${id}`;

export function LinkCampanhaSecao({ id }: { id: string }) {
  const { t } = useTranslation(['formulario', 'convites']);
  const { copiar, copiado, manual } = useCopiar();
  const url = linkDaCampanha(id);

  return (
    <section className="flex flex-col gap-4">
      <h2 className="text-lg font-semibold text-foreground">{t('link.titulo')}</h2>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <code className="min-w-0 flex-1 select-all break-all rounded-md border border-border px-3 py-2 font-mono text-sm">
          {url}
        </code>
        {/* O botão mostra o check no lugar do toast (spec 31 §6.1). */}
        <Button
          variant="secondary"
          leftIcon={
            copiado ? (
              <Check aria-hidden className="size-4" />
            ) : (
              <Copy aria-hidden className="size-4" />
            )
          }
          onClick={() => void copiar('link', url)}
        >
          {copiado ? t('convites:lembrar.linkCopiado') : t('link.copiar')}
        </Button>
      </div>
      {manual && <TextoParaCopiar texto={manual.texto} rotulo={t('link.titulo')} />}
    </section>
  );
}
